module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lmn85"))).then(() => parcelRequire('d0iPb'));